import React from 'react'
import EmployeeResponsiveDrawer from '../../components/Employeedashboard'
import { Outlet } from 'react-router-dom'


export default function EmployeeDashboardsMain() {
  return (
    <div>
        <EmployeeResponsiveDrawer/>
        <Outlet/>
    </div>
  )
}
